// WHERE THE SKILL PAGES LIVE: every one at `/skills/<slug>`, whichever area
// runs it, so a skill keeps one address however the areas are rearranged. A
// skill in the registry finds its page with `skillPath` (skills/skills.ts); this
// file holds the section's root and the one page that is not a registry skill.
//
// Zero imports, erasable TS.

/**
 * The Skills section: one node in lib/route-access.ts, one layout
 * (app/skills/layout.tsx), and its own page, every skill in a table with an
 * Active and a Retired tab (`?tab=`; lib/skills-page.ts).
 */
export const SKILLS_PATH = "/skills";

/** The Retired tab: where /settings/retired-skills went, and where a retired skill's page and its LLM costs row link back to. */
export const RETIRED_SKILLS_HREF = "/skills?tab=retired";

/**
 * Script Grading's Graded Runs tab: where /admin/grades went, and where a
 * run's crumb goes back to. Typed, as this file imports nothing;
 * tests/unit/skill-urls.test.ts holds it to `skillPath("grading")`.
 */
export const GRADED_RUNS_HREF = "/skills/script-grading?view=runs";

/**
 * Report Review: the Weekly Report's Check report, in words and in data. It
 * calls no model, so it has no registry entry and no slug there; its page is
 * listed here as the one extra.
 */
export const REPORT_REVIEW_SKILL_PATH = "/skills/report-review";

/** Its name, where the registry's `name` would be: its page's title and its row on the Skills page. */
export const REPORT_REVIEW_NAME = "Report Review";

/**
 * What it does and where, in the registry's `summary` shape (one sentence):
 * its row on the Skills page. Written from the code that runs it: the report
 * page's panel, Mark as final, and the one-time draft (lib/weekly-report-check.ts).
 */
export const REPORT_REVIEW_SUMMARY =
  "Checks a weekly report's words and numbers against its rules as the AM writes it, before Mark as final, and on the one-time draft.";
